import {
  Button,
  Checkbox,
  Column,
  ComboBox,
  FileUploaderDropContainer,
  Form,
  FormLabel,
  Grid,
  Row,
  TextInput,
  Tile,
} from 'carbon-components-react';
import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import Select from 'react-select';
import Creatable from 'react-select/creatable';
import Padding from '../../components/Padding';
import UIShell from '../../components/UIShell';
import PageHelper from '../../helpers/Pagehelper';
import ReactPlayer from 'react-player';
import { STATUSES, STATUSES_UP } from '../../utils/constants';
import { fetchAllCreatives } from '../../redux/actions/accountAction';
import { fetchAll } from '../../redux/actions/categoryAction';
import {
  changeThumbnail,
  createProject,
  getProject,
  updateProject,
} from '../../redux/actions/projectAction';
import { fetchAllSkillSelectable } from '../../redux/actions/skillAction';

import './ProjectFormPage.scss';

const statusOptions = [
  { label: STATUSES.PUBLISHED, value: STATUSES_UP.PUBLISHED },
  { label: STATUSES.DRAFT, value: STATUSES_UP.DRAFT },
];

const featuredOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

function ProjectFormPage({
  dataCreatives,
  dataCategoriesSelectable,
  dataSkillsSelectable,
  isLoading,
}) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { projectId } = useParams();

  const [formContent, setFormContent] = useState({
    projectId: undefined,
    accountId: undefined,
    title: undefined,
    description: undefined,
    projectUrl: undefined,
    company: undefined,
    skills: [],
    videoUrl: undefined,
    galleries: [],
    categories: [],
    status: undefined,
    isFeatured: undefined,
    featured: null,
  });

  const uploadProfilePicture = async (v, oldThubmnail) => {
    PageHelper.getBase64(v.target.files[0], async (_result) => {
      dispatch(
        changeThumbnail(
          {
            projectId,
            oldThubmnail,
            thumbnail: _result,
            accountId: formContent.accountId,
          },
          () => {
            setFormContent((_state) => ({
              ..._state,
              galleries: _state.galleries.map((item) => {
                if (item?.video?.thumbnail === oldThubmnail) {
                  return {
                    ...item,
                    video: {
                      ...item?.video,
                      thumbnail: _result,
                    },
                  };
                } else {
                  return item;
                }
              }),
            }));
          }
        )
      );
    });
  };

  const submitForm = (e) => {
    e.preventDefault();

    if (projectId) {
      dispatch(updateProject(formContent, () => history.push('/projects')));
    } else {
      dispatch(createProject(formContent, () => history.push('/projects')));
    }
  };

  useEffect(() => {
    const fetchInitial = async () => {
      await dispatch(fetchAllCreatives());
      await dispatch(fetchAll());
      await dispatch(fetchAllSkillSelectable());

      if (projectId && dataCategoriesSelectable.length) {
        dispatch(
          getProject({ projectId }, (_result) => {
            const featuredId = _result.galleries?.find((g) => g.featured)?.['_id'] || null;

            setFormContent((_state) => ({
              ..._state,
              ..._result,
              projectId: _result._id,
              categories: _result.categories?.map((v) => ({
                value: v,
                label: dataCategoriesSelectable.find((cat) => cat.value === v)?.label,
              })),
              skills: _result.skills?.map((v) => ({
                value: v,
                label: v,
              })),
              galleries: _result.galleries
                ? _result.galleries.map((v) =>
                  v.type === 'IMAGE'
                    ? {
                      _id: v._id,
                      img: v.url,
                      type: 'IMAGE',
                      aspect: v.aspect || null,
                      featured: v.featured || false,
                    }
                    : {
                      _id: v._id,
                      video: {
                        videoUrl: v.videoUrl || v.video,
                        thumbnail: v.thumbnail,
                      },
                      type: 'VIDEO',
                    }
                )
                : [],
              status: {
                value: _result.status,
                label:
                  _result.status === STATUSES_UP.PUBLISHED ? STATUSES.PUBLISHED : STATUSES.DRAFT,
              },
              isFeatured: {
                value: _result.isFeatured,
                label: _result.isFeatured ? 'Yes' : 'No',
              },
              featured: featuredId,
            }));
          })
        );
      }
    };

    fetchInitial();
  }, [dataCategoriesSelectable.length]);

  return (
    <UIShell
      breadcrumbs={[
        { name: 'Home', link: '/' },
        { name: 'Project', link: '/projects' },
        { name: projectId ? 'Edit' : 'Create' },
      ]}>
      <Grid>
        <Row>
          <Column>
            <Tile>
              <Form onSubmit={submitForm}>
                <Padding bottom="2rem">
                  <ComboBox
                    titleText="Creative"
                    placeholder="Select Creative"
                    value={
                      formContent.accountId
                        ? dataCreatives.find((v) => v.id === formContent.accountId)?.text
                        : undefined
                    }
                    items={dataCreatives}
                    itemToString={(item) => (item ? item.text : '')}
                    onChange={(v) =>
                      setFormContent((_state) => ({
                        ..._state,
                        accountId: v?.selectedItem?.id,
                      }))
                    }
                    light
                  />
                </Padding>

                <TextInput
                  labelText="Title"
                  value={formContent.title}
                  onChange={(v) =>
                    setFormContent((_state) => ({
                      ..._state,
                      title: v.target.value,
                    }))
                  }
                  style={{ marginBottom: '2rem' }}
                  light
                />

                <TextInput
                  labelText="Description"
                  value={formContent.description}
                  onChange={(v) =>
                    setFormContent((_state) => ({
                      ..._state,
                      description: v.target.value,
                    }))
                  }
                  style={{ marginBottom: '2rem' }}
                  light
                />

                <TextInput
                  labelText="Project Url"
                  value={formContent.projectUrl}
                  onChange={(v) =>
                    setFormContent((_state) => ({
                      ..._state,
                      projectUrl: v.target.value,
                    }))
                  }
                  style={{ marginBottom: '2rem' }}
                  light
                />

                <TextInput
                  labelText="Company"
                  value={formContent.company}
                  onChange={(v) =>
                    setFormContent((_state) => ({
                      ..._state,
                      company: v.target.value,
                    }))
                  }
                  style={{ marginBottom: '2rem' }}
                  light
                />

                <Padding bottom="2rem">
                  <FormLabel>Skills</FormLabel>
                  <Creatable
                    options={dataSkillsSelectable}
                    value={formContent.skills}
                    isMulti={true}
                    onChange={(v) =>
                      setFormContent((_state) => ({
                        ..._state,
                        skills: v,
                      }))
                    }
                  />
                </Padding>

                <Padding bottom="2rem">
                  <FormLabel>Categories</FormLabel>
                  <Select
                    isMulti={true}
                    value={formContent.categories}
                    options={dataCategoriesSelectable}
                    onChange={(v) =>
                      setFormContent((_state) => ({
                        ..._state,
                        categories: v,
                      }))
                    }
                  />
                </Padding>

                <Padding bottom="2rem">
                  {formContent.galleries?.map((file) => {
                    const isImage = file.type === 'IMAGE';
                    const isVertical = file.aspect === 'vertical';
                    const isFeatured = formContent.featured === file._id;
                    const disableOthers = formContent.featured !== null && !isFeatured;

                    return isImage ? (
                      <div
                        key={file._id}
                        style={{
                          borderBottom: '1px solid #ccc',
                          paddingBottom: '1rem',
                          marginBottom: '1rem',
                        }}>
                        {(!formContent.isFeatured?.value || isVertical) && (
                          <Checkbox
                            labelText="Cover Image"
                            id={`featured-checkbox-${file._id}`}
                            checked={isFeatured}
                            disabled={disableOthers}
                            onChange={() =>
                              setFormContent((_state) => ({
                                ..._state,
                                featured: isFeatured ? null : file._id,
                              }))
                            }
                          />
                        )}
                        <img
                          src={file?.img?.initialImg || file?.img?.croppedImg || file?.img}
                          style={{
                            width: 300,
                            margin: '0 10px 0 0',
                            borderRadius: 5,
                          }}
                          alt="image"
                        />
                      </div>
                    ) : (
                      <div key={file._id} style={{ width: '40%', marginBottom: '2rem' }}>
                        <ReactPlayer
                          url={file.video.videoUrl}
                          light={file.video.thumbnail || true}
                          width="100%"
                          height="100%"
                          controls
                        />
                        <Padding bottom="2rem">
                          <FileUploaderDropContainer
                            multiple={true}
                            labelText="Change Thumbnail"
                            title="Change Thumbnail"
                            onAddFiles={(e) => uploadProfilePicture(e, file.video.thumbnail)}
                          />
                        </Padding>
                      </div>
                    );
                  })}
                </Padding>

                <Padding top="2rem">
                  <FormLabel>Status</FormLabel>
                  <Select
                    value={formContent.status}
                    onChange={(v) =>
                      setFormContent((_state) => ({
                        ..._state,
                        status: v,
                      }))
                    }
                    options={statusOptions}
                  />
                </Padding>

                <Padding top="2rem">
                  <FormLabel>Featured</FormLabel>
                  <Select
                    value={formContent.isFeatured}
                    isDisabled={
                      !formContent.isFeatured?.value && (!formContent.galleries || !formContent.featured || formContent.galleries?.some(
                        (item) =>
                          item._id === formContent.featured &&
                          item.aspect === 'horizontal'
                      ))
                    }
                    onChange={(v) =>
                      setFormContent((_state) => ({
                        ..._state,
                        isFeatured: v,
                      }))
                    }
                    options={featuredOptions}
                  />
                </Padding>

                <Padding top="1rem">
                  <Button disabled={isLoading} type="submit" kind="primary">
                    Save
                  </Button>
                  <Button onClick={() => history.push('/projects')} kind="secondary">
                    Cancel
                  </Button>
                </Padding>
              </Form>
            </Tile>
          </Column>
        </Row>
      </Grid>
    </UIShell>
  );
}

const mapStateToProps = (state) => ({
  isLoading: state.uxReducer.isLoading,
  dataCreatives: state.accountReducer.dataCreatives,
  dataCategoriesSelectable: state.categoryReducer.dataCategories,
  dataSkillsSelectable: state.skillReducer.dataSkillsSelectable,
});

export default connect(mapStateToProps)(ProjectFormPage);
